import Model from "./Model";
import Session from "./Session";

export default class SessionStats extends Model {

	constructor(props) {

		super({});

		this.setDefaultValues({
			session: new Session(),
			collection: null,
			item_id: null,
			tags: null,
			meta: null,
			showned_on: null,
			answered_on: null,
		}, props);
	}
}
